import {
  PRODUCT_SET_CREATE_REQUEST,
  PRODUCT_SET_CREATE_SUCCESS,
  PRODUCT_SET_CREATE_FAIL,
  PRODUCT_SET_LIST_REQUEST,
  PRODUCT_SET_LIST_SUCCESS,
  PRODUCT_SET_LIST_FAIL,
  PRODUCT_SET_DETAILS_REQUEST,
  PRODUCT_SET_DETAILS_SUCCESS,
  PRODUCT_SET_DETAILS_FAIL,
  PRODUCT_SET_UPDATE_REQUEST,
  PRODUCT_SET_UPDATE_SUCCESS,
  PRODUCT_SET_UPDATE_FAIL,
  PRODUCT_SET_UPDATE_RESET,
  PRODUCT_SET_DELETE_REQUEST,
  PRODUCT_SET_DELETE_SUCCESS,
  PRODUCT_SET_DELETE_FAIL,
  PRODUCT_SET_CREATE_RESET,
} from "../constants/productSetConstants";

// Reducer to handle product set creation
export const productSetCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_SET_CREATE_REQUEST:
      return { loading: true };
    case PRODUCT_SET_CREATE_SUCCESS:
      return { loading: false, success: true, productSet: action.payload.data };
    case PRODUCT_SET_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_SET_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer to handle fetching all product sets
export const productSetListReducer = (state = { productSets: [] }, action) => {
  switch (action.type) {
    case PRODUCT_SET_LIST_REQUEST:
      return { loading: true, productSets: [] };
    case PRODUCT_SET_LIST_SUCCESS:
      return { loading: false, productSets: action.payload.data };
    case PRODUCT_SET_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer to handle fetching a product set by ID
export const productSetDetailsReducer = (
  state = { productSet: {} },
  action
) => {
  switch (action.type) {
    case PRODUCT_SET_DETAILS_REQUEST:
      return { loading: true, ...state };
    case PRODUCT_SET_DETAILS_SUCCESS:
      return { loading: false, productSet: action.payload.data };
    case PRODUCT_SET_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer to handle updating a product set
export const productSetUpdateReducer = (state = { productSet: {} }, action) => {
  switch (action.type) {
    case PRODUCT_SET_UPDATE_REQUEST:
      return { loading: true };
    case PRODUCT_SET_UPDATE_SUCCESS:
      return { loading: false, success: true, productSet: action.payload.data };
    case PRODUCT_SET_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_SET_UPDATE_RESET:
      return { productSet: {} };
    default:
      return state;
  }
};

// Reducer to handle deleting a product set
export const productSetDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_SET_DELETE_REQUEST:
      return { loading: true };
    case PRODUCT_SET_DELETE_SUCCESS:
      return { loading: false, success: true };
    case PRODUCT_SET_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
